import { __assign, __rest } from "tslib";
import React from 'react';
import { withBemMod } from '@bem-react/core';
import { useComponentRegistry } from '@bem-react/di';
import { cnUserPic } from '../UserPic';
/**
 * Модификатор, отвечающий за появление иконки камеры на user-pic без аватара.
 * @param {IUserPicHasCameraProps} props
 */
export var withCamera = withBemMod(cnUserPic(), { hasCamera: true }, function (UserPic) {
    return function (_a) {
        var origin = _a.origin, cameraURL = _a.cameraURL, hasCamera = _a.hasCamera, addonAfter = _a.addonAfter, cameraURLTarget = _a.cameraURLTarget, props = __rest(_a, ["origin", "cameraURL", "hasCamera", "addonAfter", "cameraURLTarget"]);
        var Camera = useComponentRegistry(cnUserPic()).Camera;
        var cameraAvailable = !props.avatarId || props.avatarId === '0/0-0';
        return (React.createElement(UserPic, __assign({}, props, { addonAfter: React.createElement(React.Fragment, null,
                cameraAvailable &&
                    React.createElement(Camera, { origin: origin, cameraURL: cameraURL, cameraURLTarget: cameraURLTarget }),
                addonAfter) })));
    };
});
